import React, {Fragment} from "react";
import {Input} from "reactstrap";
import ToastHelper from "utils/ToastHelper";
import FileUtil from "../domain/Util/FileUtil";
import SFXButtonComponent from "./SFXButtonComponent";
import {BrowserView, MobileView} from "react-device-detect";
import ImageViewComponent from "./ImageViewComponent";

export default class S3DocumentUploadComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fileName: "",
            fileUpload: null,
            fileSize: 0,
            filePreview: null,
            showFilePreviewText: true,
            maxSize: this.props.maxSize === undefined ? 5242880 : this.props.maxSize,
            buttonConfig: this.props.buttonConfig !== undefined ? this.props.buttonConfig : ""
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = event => {
        if (event.target.files[0].size > this.state.maxSize) {
            this.setState({
                fileName: "",
                fileUpload: null,
                fileSize: 0,
                filePreview: null,
                showFilePreviewText: false,
            });
            ToastHelper.error("Only files less than " + FileUtil.getSizeInMB(this.state.maxSize) + " MB allowed.")
            if (this.props.onFileSelected !== undefined)
                this.props.onFileSelected(null);
        } else {
            this.setState({
                fileName: event.target.value,
                fileUpload: event.target.files[0],
                fileSize: event.target.files[0].size,
                filePreview: URL.createObjectURL(event.target.files[0]),
                showFilePreviewText: false,
            });
            if (this.props.onFileSelected !== undefined) {
                this.props.onFileSelected(
                    {
                        fileName: event.target.value,
                        fileUpload: event.target.files[0],
                        fileSize: event.target.files[0].size,
                        filePreview: URL.createObjectURL(event.target.files[0]),
                        showFilePreviewText: false,
                    }
                );
            }
        }
    };

    getFileName() {
        return this.props.fileName || this.state.fileName;
    }

    render() {

        if (this.props.documentType === undefined) {
            return <Fragment>No document type specified.</Fragment>;
        }
        return <Fragment>

            <div className={this.props.className + "_register_upload_body"}>
            <h6 className={this.props.className + "_register_upload_document_text"}>
                {this.state.buttonConfig.buttonHeader}
            </h6>

            <div className={this.props.className + "_register_image_upload_button_div"} style={{paddingLeft: "60px"}}>
                <div style={{display: "flex"}}>
                    {this.props.buttonConfig !== undefined
                        ? <SFXButtonComponent
                            className={"fa fa-camera mobile_register_upload_image_button"}
                            disabled={this.props.disabled !== undefined ? this.props.disabled : false}
                        >Upload {this.state.buttonConfig.buttonText}
                        </SFXButtonComponent>

                        : <SFXButtonComponent
                            className={"fa fa-camera mobile_register_upload_image_button"}
                            disabled={this.props.disabled !== undefined ? this.props.disabled : false}
                        >Select a Document</SFXButtonComponent>
                    }
                    {this.props.fileSelected === true
                        ? <div className={"fa fa-check-circle"}
                               style={{fontSize: "25pt", color: "green", marginLeft: "10px"}}/>
                        : <div className={"fa fa-check-circle"}
                               style={{fontSize: "25pt", color: "white", marginLeft: "10px"}}/>
                    }
                </div>

                <Input
                    type="file"
                    value={this.getFileName()}
                    onChange={this.handleChange.bind(this)}
                    accept="image/*"
                    disabled={this.props.disabled !== undefined ? this.props.disabled : false}
                    capture
                />
            </div>

            </div>

            <div className={this.props.className + "_register_upload_body"}>
                {this.state.fileName.includes(".pdf") ?
                    <img className={"img-preview"} src={"/images/pdf-icon.png"} alt={""}/>
                    :
                    <img className={"img-preview"} src={this.state.filePreview} alt={""}/>
                }
            </div>
        </Fragment>
    }

    static renderImageDisplay(file) {

        if (file === undefined)
            return <Fragment>No file specified</Fragment>;

        let src = file.filePreview || file.presignedUrl || file.preSignedUrl;

        return <div className={"pull-left"} style={{display: "block"}}>
            <BrowserView>
                <ImageViewComponent
                    src={src}
                    fileName={file.fileName}
                    style={{
                        maxHeight: '200px',
                        maxWidth: '300px',
                        width: "100%"
                    }}
                    alt={""}
                />

            </BrowserView>
            <MobileView>
                <ImageViewComponent
                    src={src}
                    fileName={file.fileName}
                    style={{
                        maxHeight: '30vh',
                        maxWidth: '40vw',
                        width: "100%"
                    }}
                    alt={""}
                />

            </MobileView>
        </div>
    }
}
